'use strict';

$(document).ready(function() {
    function featuredCatSlider() {
        const $carouselWrapper = $('.featured-cat-wrapper');
        const _carouselOptions = {
            infinite: false,
            slidesToShow: 2.5,
            slidesToScroll: 2
        }
        if((window.matchMedia('(max-width: 544px)').matches) && $carouselWrapper.length > 0) {
            if (!$carouselWrapper.hasClass('slick-initialized')) {
                $carouselWrapper.slick(_carouselOptions);
            }
        } else {
            if ($carouselWrapper.hasClass('slick-initialized')) {
                $carouselWrapper.slick('unslick');
            }
        }
    }

    featuredCatSlider();

    $(window).on('resize orientationchange', function() {
        featuredCatSlider();
    });
});
